export const SECOND = 1000;

export const SEEK_RANGE = 15;

export const LIKE = 'like';
export const DISLIKE = 'dislike';
